import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import Image from '@atlaskit/image';
import { Box, xcss } from '@atlaskit/primitives';
import { token } from '@atlaskit/tokens';
import { css } from '@compiled/react';
import { useIntl } from 'react-intl-next';

import { messages } from './messages';
import listMergeAnimationDark from '../assets/list-merge-modal-dark.gif';
import listMergeAnimation from '../assets/list-merge-modal-light.gif';

const imageStyles = xcss({
	overflow: 'hidden',
	position: 'relative',
	width: '100%',
});

const onboardingImageStyles = css({
	width: '100%',
});

const closeButtonContainerStyles = xcss({
	position: 'absolute',
	top: 'space.100',
	right: 'space.100',
	zIndex: 'modal',
	borderWidth: token('border.width'),
	borderStyle: 'solid',
	borderColor: 'color.border',
	borderRadius: token('radius.small'),
});

type ModalOnboardingImageProps = {
	onClose: () => void;
};

export const ModalOnboardingImage = ({ onClose }: ModalOnboardingImageProps) => {
	const { formatMessage } = useIntl();
	return (
		<Box xcss={imageStyles}>
			{/* eslint-disable-next-line @atlassian/a11y/alt-text -- See https://go/a11y-alt-text for more details */}
			<Image
				css={onboardingImageStyles}
				src={listMergeAnimation}
				srcDark={listMergeAnimationDark}
			/>
			<Box xcss={closeButtonContainerStyles}>
				<IconButton
					appearance="subtle"
					icon={CrossIcon}
					onClick={onClose}
					label={formatMessage(messages.closeButton)}
					testId="high-impact-modal-close-button"
				/>
			</Box>
		</Box>
	);
};
